// WARNING: this file is AUTOGENERATED, only main.ts and index.ts are editable
// rerun yarn generate:enums to update

import { getLanguageProficiencyById } from 'app/constants/enums/LanguageProficiency/main';

/* eslint-disable max-len */
export const A1 = getLanguageProficiencyById('A1');
export const A2 = getLanguageProficiencyById('A2');
export const B1 = getLanguageProficiencyById('B1');
export const B2 = getLanguageProficiencyById('B2');
export const C1 = getLanguageProficiencyById('C1');
export const C2 = getLanguageProficiencyById('C2');
export const NATIVE = getLanguageProficiencyById('Native');
/* eslint-enable max-len */
